import { render, staticRenderFns } from "./MarketingEmailFormModels.vue?vue&type=template&id=21d320bb&scoped=true"
import script from "./MarketingEmailFormModels.vue?vue&type=script&lang=js"
export * from "./MarketingEmailFormModels.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailFormModels.vue?vue&type=style&index=0&id=21d320bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d320bb",
  null
  
)

export default component.exports